import { mapValues } from 'remeda';
import z from 'zod';

import { PlateTextElements, TextElementsCodec, UnityTextElements } from './Text';
import { CURRENT_VERSION, ElementId, Version } from '../commons';
import { ELEMENT_TYPES } from '../constants';

const HeadingVariantType = z.union([
    z.literal(ELEMENT_TYPES.TITLE_HEADER),
    z.literal(ELEMENT_TYPES.TITLE),
    z.literal(ELEMENT_TYPES.LEAD),
]);

export const PlateHeadingVariant = z.object({
    type: HeadingVariantType,
    id: ElementId,
    children: PlateTextElements,
});

export const UnityHeadingVariant = z.object({
    type: HeadingVariantType,
    version: Version,
    items: UnityTextElements,
});

type PlateHeadingVariant = z.infer<typeof PlateHeadingVariant>;
type UnityHeadingVariant = z.infer<typeof UnityHeadingVariant>;

export const encodeHeadingVariants = (variants: Record<string, PlateHeadingVariant>) =>
    mapValues(variants, (variant) => ({
        type: variant.type,
        version: CURRENT_VERSION,
        items: TextElementsCodec.encode(variant.children),
    }));

export const decodeHeadingVariants = (variants: Record<string, UnityHeadingVariant>) =>
    mapValues(variants, (variant) => ({
        type: variant.type,
        id: crypto.randomUUID(),
        children: TextElementsCodec.decode(variant.items),
    }));
